import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * A slim "N selected" pill shown while a MULTI-selection is active — feedback +
 * an escape hatch (Clear). It is NOT the action surface: bulk actions live in a
 * selected row's ⋯ menu (see BulkActionsMenuItems), so acting on the selection
 * feels like acting on a single task. Renders nothing for 0 or 1 selected — a
 * single selection is already conveyed by the row's own highlight, so the pill
 * would just be noise.
 */
export function SelectionIndicator({ count, onClear }: { count: number; onClear: () => void }) {
  if (count <= 1) return null;
  return (
    <div
      className="sticky top-2 z-20 flex w-fit items-center gap-2 rounded-full border bg-background/95 py-1 pl-3 pr-1 text-sm shadow-md backdrop-blur"
      role="status"
      aria-label={`${count} selected`}
      data-selection-indicator
    >
      <span className="font-medium">{count} selected</span>
      <span className="text-xs text-muted-foreground">— open a task’s ⋯ menu to act on all</span>
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
